import React, { useState } from 'react';
import { MessageSquare, Pencil, Trash2, Loader2, Send, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { adminAPI } from '../services/api';

// Admin: public shop reply under a review (create / edit / delete)
const ReviewReplyBox = ({ review, onChanged }) => {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(review.reply?.message || '');
  const [busy, setBusy] = useState(false);
  const [suggesting, setSuggesting] = useState(false);

  const save = async () => {
    if (text.trim().length < 2) return;
    setBusy(true);
    try { const r = await adminAPI.replyReview(review.id, text); toast.success(r.message); setEditing(false); onChanged(); } catch (e) { toast.error(e.response?.data?.detail || 'Enregistrement impossible'); } finally { setBusy(false); }
  };
  const suggest = async () => {
    setSuggesting(true);
    try { const r = await adminAPI.suggestReviewReply(review.id); setText(r.message); toast.success('Suggestion IA insérée — relisez et ajustez avant de publier'); } catch (e) { toast.error(e.response?.data?.detail || 'IA indisponible'); } finally { setSuggesting(false); }
  };
  const remove = async () => {
    if (!window.confirm('Supprimer la réponse publique ?')) return;
    setBusy(true);
    try { await adminAPI.deleteReviewReply(review.id); toast.success('Réponse supprimée'); setText(''); onChanged(); } catch (e) { toast.error('Suppression impossible'); } finally { setBusy(false); }
  };

  if (editing) {
    return (
      <div className="mt-2 bg-orange-50/60 border border-orange-200 rounded-lg p-3" data-testid={`review-reply-form-${review.id}`}>
        <textarea data-testid={`review-reply-input-${review.id}`} rows={3} value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm" placeholder={`Bonjour ${review.user_name}, merci pour votre avis…`} />
        <div className="flex flex-wrap justify-end gap-2 mt-2">
          <Button size="sm" variant="outline" onClick={suggest} disabled={suggesting} data-testid={`review-reply-suggest-${review.id}`} className="h-8 mr-auto border-violet-300 text-violet-700 hover:bg-violet-50">{suggesting ? <Loader2 size={14} className="animate-spin mr-1" /> : <Sparkles size={14} className="mr-1" />} {text.trim() ? 'Reformuler avec l\'IA' : 'Suggérer une réponse IA'}</Button>
          <Button size="sm" variant="outline" onClick={() => { setEditing(false); setText(review.reply?.message || ''); }} data-testid={`review-reply-cancel-${review.id}`} className="h-8">Annuler</Button>
          <Button size="sm" disabled={busy || text.trim().length < 2} onClick={save} data-testid={`review-reply-save-${review.id}`} className="h-8 bg-[#1e3a5f] hover:bg-[#2d4a6f]">{busy ? <Loader2 size={14} className="animate-spin mr-1" /> : <Send size={14} className="mr-1" />} Publier la réponse</Button>
        </div>
      </div>
    );
  }
  if (review.reply) {
    return (
      <div className="mt-2 border-l-4 border-orange-400 bg-orange-50/60 rounded-r-lg p-3 text-sm" data-testid={`admin-review-reply-${review.id}`}>
        <p className="text-xs font-semibold text-gray-800">Réponse publique · {new Date(review.reply.updated_at || review.reply.created_at).toLocaleDateString('fr-FR')} · {review.reply.auto ? <span className="inline-flex items-center gap-1 text-violet-700 bg-violet-50 border border-violet-200 rounded-full px-1.5 py-0.5" data-testid={`review-reply-auto-${review.id}`}><Sparkles size={10} /> remerciement IA auto</span> : review.reply.admin_email}</p>
        <p className="text-gray-700 mt-1 whitespace-pre-line">{review.reply.message}</p>
        <div className="flex gap-3 mt-2 text-xs">
          <button type="button" onClick={() => setEditing(true)} data-testid={`review-reply-edit-${review.id}`} className="text-blue-600 hover:underline inline-flex items-center gap-1"><Pencil size={12} /> Modifier</button>
          <button type="button" onClick={remove} disabled={busy} data-testid={`review-reply-delete-${review.id}`} className="text-red-600 hover:underline inline-flex items-center gap-1"><Trash2 size={12} /> Supprimer</button>
        </div>
      </div>
    );
  }
  return (
    <button type="button" onClick={() => setEditing(true)} data-testid={`review-reply-open-${review.id}`} className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-[#1e3a5f] hover:underline"><MessageSquare size={13} /> Répondre publiquement</button>
  );
};

export default ReviewReplyBox;
